import _ from 'lodash';
import React from 'react';

import FullscreenView from './fullscreenView.js'
import ItemLayout from '../item/itemLayout.js'
import consts from '../consts.js';
import { utils } from '../../utils/index.js';
import { versionManager } from '../../versioning/proGalleryVersionManager.js';
import { itemActions } from '../../utils'
import watermarkApi from '../../store/watermarkApi2';
import storeApi from '../../store/storeApi';

class FullscreenContainer extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.initDefaults();
    this.initGalleryInfo();

    this.resize = this.resize.bind(this);
    this.orientationChange = this.orientationChange.bind(this);

    this.state = this.prepareInitialState();

    if (utils.isDev()) console.log('FULLSCREEN - constructor');
  }

  //----------------------------------------| REACT |----------------------------------------//

  componentDidMount() {
    this.initOnce();
    this.init();
  }

  componentWillReceiveProps() {
    this.init();
  }

  componentWillUnmount() {
    clearInterval(this.videoInterval);
  }

  //-----------------------------------------| INIT |----------------------------------------//

  initDefaults() {
    this.readyToRender = true;
    this.parseStyleParams({}); //set defaults (sync)
    this.navigatedInto = false;
    this.extraImages = utils.isMobile() ? 2 : 5; //number of images to preload on each side of the fullscre
  }

  initOnce() {

    if (utils.isDev()) console.log('FULLSCREEN - initOnce');

    this.initNavigationEvents();

  }

  init() {

    if (this.isPreload()) return;

    if (utils.isDev()) console.log('FULLSCREEN - init');

    this.isOpen = true;

    this.initEvents();
    this.initGalleryInfo();
    this.initStyleParams();
    this.initExpandSettingsMode();

    this.resize(); //set initial size

    this.setCurrentItem(); //set initial item
    // var isIE = utils.browserIs('explorer');
    // if (!isIE) {
    //this.cancelOpenHttpRequests(); //removed because it is causeing the fullscreen to be flaky
    // }

    this.handleMouseMove(); //show the icons (that will show on mouse move) on startup

    utils.setStateAndLog(this, 'init', this.prepareInitialState());
    this.initWatermark();

  }

  initStyleParams() {
    this.parseStyleParams({}); //set defaults (sync)
    this.getStyleParams(); //get real params (async)
  }

  initGalleryInfo() {
    let compId = utils.getWorkerWindow()['pro-gallery-fullscreen-comp-id'];
    if (compId === 'null') {
      compId = false;
    }

    try {
      if (utils.isInWix()) {
        //this.galleryWindow = window.parent.document.getElementById(this.galleryInfo.compId).getElementsByTagName('iframe')[0].contentWindow;
        this.galleryWindow = utils.getGalleryByCompId(compId) || window; //using || window is for cases where the fullscreen is loaded without a gallery (e.g. direct link)
        this.galleryData = utils.getWorkerWindow()['pro-gallery-data-' + compId] || {};
      } else {
        this.galleryData = window['pro-gallery-data-' + compId] || {};
        this.galleryWindow = window;
      }
    } catch (e) {
      this.galleryData = {};
      this.galleryWindow = window;
    }

    if (this.galleryData.info) {
      //if the galleryWindow exist (fullscreen was open via click on item in gallery - use it to get the data
      this.galleryInfo = this.galleryData.info;
      this.navigatedInto = true;
    } else if (utils.isInWix()) {
      //if the galleryWindow does not exist (fullscreen was open via direct URL)
      let watermarkData = null;
      let connectedProviders = null;
      if (utils.isStoreGallery()) {
        connectedProviders = window.connectedProviders;

        if(!connectedProviders && utils.isInSettings()) {
          storeApi.getStoreGalleryData().then(connectedProviders => {
            this.galleryInfo = Object.assign({}, this.galleryInfo,connectedProviders);
            this.setState({connectedProviders: true}); // render
          });
        }
      }

      this.galleryInfo = {
        compId: (compId || utils.parsePathParam('comp-') || utils.parseGetParam('c') || utils.parseHashParam('c') || ''),
        pageId: (utils.parseGetParam('p') || utils.parseHashParam('p') || ''),
        styleId: (utils.parseGetParam('s') || utils.parseHashParam('s') || ''),
        hashtag: (utils.parseGetParam('ht') || utils.parseHashParam('ht') || ''),
        reachLevel: (utils.parseGetParam('rl') || utils.parseHashParam('rl') || 0),
        galleryId: window.galleryId,
        watermarkData: watermarkData,
        connectedProviders: connectedProviders,
      };
    } else {
      this.galleryInfo = {
        compId: "none",
        pageId: "none",
        styleId: "none",
        hashtag: "none",
        galleryId: "none",
        reachLevel: 0,
        watermarkData: {},
        connectedProviders: {}
      };
    }

    if (utils.isStoreGallery()) {
      if (!this.galleryInfo.galleryId && utils.isInSettings()) {
        this.galleryInfo.galleryId = utils.parseGetParam('galleryId')
      }
      this.setState({
        showShopFrame: (this.galleryInfo.config && this.galleryInfo.config.openShop),
        showShareScreen: false
      });
    }

    //use the compId to find the gallery window

    Wix.Utils.getSectionUrl({ sectionId: utils.getFullscreenSectionId() }, (res) => {
      this.fullscreenUrl = res.url;
      itemActions.initWidgetData({
        compId: this.galleryInfo.compId,
        pageId: this.galleryInfo.pageId,
        styleId: this.galleryInfo.styleId,
        galleryId: this.galleryInfo.galleryId,
        fullscreenUrl: this.fullscreenUrl,
      });

      itemActions.setReachLevel(this.galleryInfo.reachLevel, this.galleryInfo.hashtag)
    });

    Wix.getSitePages((pages) => {
      var page = _.find(pages, { title: 'Fullscreen Page' });
      this.pageId = (page && page.id) || '';
    });
  }

  initNavigationEvents() {

    if (utils.isDev()) console.log('FULLSCREEN - initNavigationEvents (start)');

    if (utils.isInWix()) {

      if (utils.isDev()) console.log('FULLSCREEN - initNavigationEvents (isInWix)');

      if (!utils.isSite() || utils.isInSettings()) {

        if (utils.isDev()) console.log('FULLSCREEN - initNavigationEvents (!isSite)');

        window.addEventListener('message', ((e) => {
          if (e.data.type == Wix.Events.STYLE_PARAMS_CHANGE) {
            this.onNewStyleParams(e.data.payload);
          }
        }));

        Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, () => {
          const viewMode = utils.updateViewMode();

          //fullscreen should always be closed in editor mode
          if (utils.isEditor()) {
            this.closeFullscreen();
          }

          Wix.getCurrentPageId((pageId) => {
            if (this.navigatedInto || this.pageId === pageId) {
              this.closeFullscreen();
            }
          });
        });
      }

      Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, (data) => {
        if (utils.isDev()) console.log('FULLSCREEN - PAGE_NAVIGATION_IN', data);
        if (data && data.isAppOnPage) {
          this.navigatedInto = true;
          Wix.getCurrentPageId((pageId) => {
            this.pageId = pageId;
          });

          this.init();
        }
      });
      Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, (data) => {
        if (utils.isDev()) console.log('FULLSCREEN - PAGE_NAVIGATION_OUT', data);
        if (data && data.wasAppOnPage) {
          this.prepareToClose();
          if (_.isFunction(this.props.closeFullscreenCallback)) {
            this.props.closeFullscreenCallback(this.state.current.idx);
          } else if (this.galleryWindow) {
            this.galleryWindow.dispatchEvent(this.fullscreenClosedEvent);
          }
          utils.setStateAndLog(this, 'PAGE_NAVIGATION_OUT', {
            readyToRender: false
          });
        }
      });
    } else {
      //close fullscreen on back button
      window.onpopstate = () => this.closeFullscreen();
    }

  }

  initEvents() {

    this.handleMouseMove = _.throttle(() => {
      $('.fullscreen-icon').show().css('opacity', '1');
      $('body').removeClass('no-cursor');
      clearTimeout(this.mouseMovedTimeout);

      if (this.isBrowserExpanded()) {
        if (!this.getItem().isDemo && !utils.isTouch()) {
          this.mouseMovedTimeout = setTimeout(() => {
            $('body').addClass('no-cursor');
            $('.fullscreen-icon').css('opacity', '0');
          }, 3000);
        }
      }
    }, 100).bind(this);

    this.handleKeypress = _.throttle((e) => {

      switch (e.keyCode || e.charCode) {
        case 38: //up
        case 37: //left
        case 33: //page up
          e.preventDefault();
          this.nextSlide(-1);
          return false;
        case 39: //right
        case 40: //down
        case 34: //page down
          e.preventDefault();
          this.nextSlide(1);
          return false;
        case 27: //esc
          e.preventDefault();
          this.handleMouseMove();
          this.closeFullscreen();
          return false;
      }
      this.handleMouseMove();
      return true; //continue handling the original keyboard event
    }, 100).bind(this);

    this.fullscreenClosedEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
    this.fullscreenClosedEvent.initCustomEvent('fullscreen_closed', false, false, null);

    this.debouncedResizeEvent = _.debounce(this.resize, 100);

    window.addEventListener('keydown', this.handleKeypress);
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('mousedown', this.handleMouseMove);

    window.addEventListener('resize', this.debouncedResizeEvent);
    window.addEventListener('orientationchange', this.orientationChange);

  }

  clearEvents() {
    window.removeEventListener('keydown', this.handleKeypress);
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('mousedown', this.handleMouseMove);

    window.removeEventListener('resize', this.debouncedResizeEvent);
    window.removeEventListener('orientationchange', this.orientationChange);
  }

  initExpandSettingsMode() {

    if (utils.isInSettings()) {
      try {
        window.parent.postMessage({
          type: "FULLSCREEN_WINDOW_LOADED"
        }, utils.getUrlPrefix());

        var stylesheets = utils.findFontsHrefs(); //Adding stylesheets for fonts
        for (var stylesheet of stylesheets) {
          $(document).find('head').append('<link href="' + stylesheet + '" rel="stylesheet" type="text/css" />');
        }
      } catch (e) {
        console.warn('Error initing expand settings mode', e);
      }
    }

  }

  initWatermark() {
    if (utils.isStoreGallery()) {
      if (utils.isInSettings()) {
        this.setState({
          watermarkReady: true,
          watermark: watermarkApi.defaultWatermarkData,
        }, () => {
          this.setState({
            items: this.prepareFullscreenItems(this.state.items)
          })
        });
        return;
      }
      const galleryInfo = this.galleryInfo || {};
      const watermarkData = galleryInfo.watermarkData;
      if (watermarkData) {
        this.setState({
          watermarkReady: true,
          watermark: watermarkData,
        }, () => {
          this.setState({
            items: this.prepareFullscreenItems(this.state.items)
          })
        })
      } else {
        this.setState({
          watermarkReady: true,
          watermark: watermarkApi.defaultWatermarkData,
        })
      }
    }
  }

  cancelOpenHttpRequests() {
    // this hack clears up any pending socket issues. damn it chrome.
    // be careful - it cancels any http requests
    console.warn('Open fullscreen - canceling all http requests!');
    if (window && (typeof (window['stop']) == 'function')) {
      window['stop']();
    } else if (document.execCommand !== undefined) {
      document.execCommand('Stop', false);
    }
  }

  prepareInitialState() {
    var initialItems = this.getInitialItems();
    var initialIdx = Math.min(this.getInitialItemIdx(), initialItems.length - 1);
    return {
      readyToRender: this.readyToRender,
      watermarkReady: (!utils.isStoreGallery() || utils.isInSettings()),
      showInfo: this.shouldShowInfo(initialIdx),
      showMobileShopFrame: false,
      showShareScreen: false,
      items: initialItems,
      swipperReady: false,
      showShare: false,
      isPlaying: false,
      isVideoLoading: false,
      current: this.getCurrentItemState(initialIdx),
      styleParams: this.styleParams,
      window: this.getWindowState(),
      watermark: {}
    }
  }

  //----------------------------------------| UTILS |----------------------------------------//

  isPreload() {
    if (this.prerenderedItem) {
      //direct landing on fullscreen
      return false;
    }

    if (this.navigatedInto) {
      //click from gallery
      return false;
    }

    if (utils.isInSettings()) {
      //In expand mode settings screen
      return false;
    }
    return true;

    // return !(this.galleryInfo && this.galleryInfo.compId && this.galleryInfo.pageId && this.galleryInfo.styleId);
  }

  windowSize() {
    var w = $(window);
    var dim = {
      width: Math.round(w.width() / utils.getViewportScaleRatio()),
      height: Math.round(w.height() / utils.getViewportScaleRatio())
    };

    let isMobile = utils.isMobile();
    let sidebarWidth = (versionManager.useFullScreenWideSidebar() ? consts.STORE_SIDE_BAR_WIDTH : consts.SIDE_BAR_WIDTH);
    let mobilePadding = ((versionManager.useFullScreenMobilePadding() && isMobile) ? consts.MOBILE_PADDING : consts.NO_PADDING);

    if (this.shouldShowInfo()) {
      return {
        width: dim.width - sidebarWidth,
        height: dim.height - mobilePadding
      }
    } else if (mobilePadding != 0) {
      return {
        width: dim.width,
        height: dim.height - mobilePadding
      }
    } else {
      return dim;
    }
  }

  isBrowserExpanded() {
    return (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
  }

  getWindowScale() {
    var scale = {};
    if (this.isBrowserExpanded() || utils.isSmallScreen()) {
      scale = {
        horizontal: 1,
        vertical: 1
      };
    } else {
      var w = this.windowSize();
      scale = {
        horizontal: (w.width - 100 * 2) / w.width,
        vertical: (w.height - 100 * 2) / w.height
      };
    }
    scale.min = (item) => {
      if (this.isBrowserExpanded() || utils.isSmallScreen()) {
        return 1;
      } else {
        var w = this.windowSize();
        var horizontal = (w.width - 100 * 2) / item.width;
        var vertical = (w.height - 100 * 2) / item.height;
        return Math.min(horizontal, vertical);
      }
    }
    return scale;
  }

  getWindowState() {
    return {
      size: this.windowSize(),
      expanded: this.isBrowserExpanded(),
      scale: this.getWindowScale()
    }
  }

  shouldShowInfo(idx) {
    if (utils.isStoreGallery() && !utils.isMobile()) {
      return true;
    } else if (this.isBrowserExpanded()) {
      return false;
    } else if (this.state) {
      return (this.state.showInfo && this.hasInfo(idx))
    } else {
      return ((this.styleParams.defaultShowInfoExpand === 1) && !utils.isSmallScreen())
    }
  }

  hasInfo(idx) {

    var curItem;

    if (!_.isUndefined(idx)) {
      curItem = this.getItem(idx);
    } else {
      curItem = this.getItem(_.get(this, 'state.current.idx') || 0);
    }

    return (((curItem.title || curItem.fileName) && this.styleParams.allowTitleExpand) || (curItem.description && this.styleParams.allowDescriptionExpand)) || (curItem.linkUrl && utils.isMobile()); // curItem.isDemo);
  }

  //------------------------------------| ITEMS MANAGER |------------------------------------//

  getItem(idx) {
    var emptyItem = {
      id: '',
      full_url: {}
    };
    if (!this.state) {
      return emptyItem;
    } else if (!_.isUndefined(idx) && _.isArray(this.state.items)) {
      return this.state.items[idx] || emptyItem;
    } else {
      if (_.get(this, 'state.current.item.id')) {
        return this.state.current.item;
      } else if (this.state.items[_.get(this, 'state.current.idx')]) {
        return this.state.items[_.get(this, 'state.current.idx')];
      } else if (_.get(this, 'prerenderedItem.id')) {
        return this.prerenderedItem;
      } else {
        return emptyItem;
      }
    }
  }

  getCurrentItemState(idx) {

    if (_.isUndefined(idx)) {
      idx = this.state.current.idx || 0;
    }

    var currentItemState = ({
      idx,
      item: this.getItem(idx),
      hasInfo: this.hasInfo(idx),
      pos: this.getItemsDisplayRange()
    });

    return currentItemState;
  }

  setCurrentItem(idx) {
    var currentItemState = this.getCurrentItemState(idx);
    utils.setStateAndLog(this, 'setCurrentItem', { current: currentItemState }, () => {
      this.replaceCurrentUrl();
    });
  }

  createItem(itemDto, idx) {
    if (itemDto.dto) { //the item is already an object
      return itemDto;
    }
    return new ItemLayout({
      idx: idx,
      dto: (itemDto.dto || itemDto),
      cubeImages: false,
      createdBy: 'fullscreenCreateItem'
    });
  }

  getInitialItemIdx() {
    try {
      return Number(this.galleryInfo.itemIdx || utils.parseGetParam('i') || utils.parseHashParam('i') || this.props.demoModeParams.item || 0);
    } catch (e) {
      return 0;
    }
  }

  getInitialItems() {

    console.time('Fullscreen Class - PREPARE ITEMS');

    let items;
    const prerenderedItem = window['prerenderedItem'];

    if (this.galleryData && this.galleryData.items) {
      try {
        this.galleryLayout = this.galleryData.items.galleryLayout;
        this.totalItemsCount = this.galleryData.items.totalItemsCount;
        this.currentGalleryItems = this.galleryData.items.currentGalleryItems;
      } catch (e) {
        console.warn('Could not find galleryWindow items', e);
        this.totalItemsCount = this.props.totalItemsCount || 1;
      }
    } else {
      this.totalItemsCount = this.props.totalItemsCount || 1;
    }

    if (this.currentGalleryItems && this.galleryLayout) { //Opened from the Gallery -> get the items from the gallery window

      items = this.currentGalleryItems;

      this.galleryItems = {};
      _.flattenDeep(this.galleryLayout.columns.map((column) => {
        return column.map((group) => {
          return group.items
        });
      })).forEach((item) => {
        this.galleryItems[item.photoId] = item;
      });

      for (let i = 0; items[i]; i++) {
        items[i] = this.createItem(items[i], i);
      }

    } else if (prerenderedItem && prerenderedItem.items) { //Opened directly via deep link -> get the first item from the prerendered gallery

      items = prerenderedItem.items;

      this.prerenderedItem = new ItemLayout({
        dto: items[0],
        createdBy: 'fullscreenGetInitialItems'
      });

      this.totalItemsCount = 1; //keep count at 1 until more items arrive

      //use the infinite scroll url to get all the items up to this one
      this.prerenderedItems = [];
      this.completeMissingItems();

    } else if (window['emptyImages']) { //Not opened yet (preload) or some sort of error -> get the sample images

      const shouldShowSampleImages = (utils.isDev() || utils.isInSettings());

      items = shouldShowSampleImages ? window['sampleImages'].photos : window['emptyImages'].photos;
      this.totalItemsCount = items.length;

      if (!this.isPreload()) {
        //displaying the sample images is just as placeholders - the fullscreen should be closed
        if (utils.isDev()) console.log('Closing fullscreen automatically (emptyImages are displayed while not in preload)');
        this.closeFullscreen();
      } else {
        //check if the fullscreen is the current page viewed and it displays empty (gray) images - if it is, close it
        if (!shouldShowSampleImages) {
          Wix.getSiteInfo((siteInfo) => {
            if (siteInfo && siteInfo.url && siteInfo.url.indexOf('fullscreen-page') > 0) {
              if (utils.isDev()) console.log('Closing fullscreen automatically (emptyImages are displayed while page is displayed)');
              this.closeFullscreen();
            }
          });
        }
      }

    } else {

      items = [];
      this.totalItemsCount = 0;
      console.warn('No images to display on fullscreen');
    }

    items = this.prepareFullscreenItems(items);

    if (utils.isDev()) {
      console.timeEnd('Fullscreen Class - PREPARE ITEMS');
    }

    return items;
  }

  prepareFullscreenItems(srcItems) {

    if (utils.isDev()) {
      console.count('Preparing fullscreen items');
      console.time('Prepare fullscreen items');
    }

    var items = [];
    var item;
    var pointer = 0;

    var w = this.windowSize();
    var window_width = w.width;
    var window_height = w.height;
    var window_ratio = window_width / window_height;

    while (item = srcItems[pointer]) {
      const stateWatermark = _.get(this, 'state.watermark');
      const isEmptyWatermarkInState = _.isEmpty(stateWatermark);
      const watermark = isEmptyWatermarkInState ? (watermarkApi ? watermarkApi.defaultWatermarkData : null) : stateWatermark;

      item = new ItemLayout({
        idx: pointer,
        dto: srcItems[pointer].dto || srcItems[pointer], //if the item is an Item object - use the dto
        cubeImages: false,
        sharpParams: _.get(this, 'styleParams.sharpParams'),
        watermark,
        createdBy: 'prepareFullscreenItems'
      });

      var galleryItem = this.galleryItems && this.galleryItems[item.photoId];
      var useGalleryItem = galleryItem && !galleryItem.cubeImages && !(utils.isMobile() && (galleryItem.resizeWidth > window_width || galleryItem.resizeHeight > window_height)); //on mobile, use the gallery image only if its smaller than the screen (must be a light image for smooth transitions

      item.preload_img = useGalleryItem ? galleryItem.resized_url['img'] : item.thumbnail_url['img'];

      var overScale = (utils.isTouch() && item.isImage) ? 2 : 1; //bring overscaled images to make sure it remains sharp when pinching

      //calc the fullscreen sizes
      if (item.ratio > window_ratio) {
        item.resize((window_width) / item.width * overScale);
      } else {
        item.resize((window_height) / item.height * overScale);
      }

      item.width = Math.floor(item.width / overScale);
      item.height = Math.floor(item.height / overScale);

      //populate the items array
      items.push(item);

      //advance the pointer
      pointer++;
    }

    if (utils.isDev()) {
      console.timeEnd('Prepare fullscreen items');
    }

    return items;

  }

  concatNewItems(curItems, newItems) {

    if (!newItems || !newItems.length > 0) {
      return curItems;
    }

    curItems = curItems.concat(newItems);
    curItems = _.uniqBy(curItems, (item) => item.itemId || item.photoId || item.url);
    curItems = _.sortBy(curItems, (item) => item.orderIndex);
    curItems = curItems.slice(0, this.totalItemsCount);
    for (var item, i = 0; item = curItems[i]; i++) {
      item.idx = i;
    }
    return curItems;
  }

  completeMissingItems() {
    if (this.galleryInfo.hashtag) {
      //get items by hashtag
      $.get(`${utils.getApiUrlPrefix()}gallery/${window.galleryId}/hashtags/${this.galleryInfo.hashtag}/items?instance=${window.instance}`, (res) => {
        if (res && res.items && res.items.length > 0) {
          this.totalItemsCount = res.items.length;
          this.prerenderedItems = res.items;
          var requiredItemIdx = 0;
          utils.setStateAndLog(this, 'completeMissingItems #1', {
            items: this.prepareFullscreenItems(this.prerenderedItems),
            current: this.getCurrentItemState(requiredItemIdx),
            isLoved: itemActions.isLoved(this.prerenderedItems[requiredItemIdx].id),
            readyToRender: false
          }, () => {
            this.replaceCurrentUrl();
            utils.setStateAndLog(this, 'completeMissingItems #2', {
              readyToRender: true,
              isPlaying: false
            });
          });
        }
      });

    } else if (window.infiniteScrollUrl && window.instance) {
      //get items from gallery
      var batchSize = 500;
      let storeParameter = '';
      if (utils.isStoreGallery()) {
        storeParameter = `&isStore=true`;
      }
      $.get(`${window.infiniteScrollUrl}from/${this.prerenderedItems.length}/to/${this.prerenderedItems.length + batchSize}?instance=${window.instance}${storeParameter}`, (res) => {
        if (res && res.items && res.items.length > 0) {
          this.totalItemsCount = this.prerenderedItems.length + res.items.length;
          this.prerenderedItems = this.concatNewItems(this.prerenderedItems, res.items);
          var requiredItemIdx = _.findIndex(this.prerenderedItems, (item) => (item.itemId == this.prerenderedItem.itemId));
          if (requiredItemIdx >= 0 && requiredItemIdx < (this.prerenderedItems.length - 1)) { //search for the item and make sure more items exist after it
            console.log('The Item was found', requiredItemIdx);
            this.totalItemsCount = res.totalItemsCount; //now use the real total
            utils.setStateAndLog(this, 'completeMissingItems #1', {
              items: this.prepareFullscreenItems(this.prerenderedItems),
              current: this.getCurrentItemState(requiredItemIdx),
              isLoved: itemActions.isLoved(this.prerenderedItems[requiredItemIdx].id),
              readyToRender: false
            }, () => {
              this.replaceCurrentUrl();
              utils.setStateAndLog(this, 'completeMissingItems #2', {
                readyToRender: true,
                isPlaying: false
              });
            });
          } else {
            console.warn('The Item was not found! - retrying...');
            this.completeMissingItems();
          }
        }
      });
    } else {
      if (!window.infiniteScrollUrl) {
        console.warn('Could not get more items - missing infinite scroll url');
      }
      if (!window.instance) {
        console.warn('Could not get more items - missing instance');
      }
    }
  }

  getMoreItems(idx) {

    var curTo = this.state.items.length || 0;

    var to = Math.min(this.totalItemsCount, idx + this.extraImages * 5);

    if (!this.fetchingMoreItems && to > curTo) {
      this.fetchingMoreItems = true;

      to += 50;
      //to = Math.min(this.totalItemsCount + 1, to + 50);

      console.time('Fetching items from DB');

      let storeParameter = '';
      if (utils.isStoreGallery()) {
        storeParameter = `&isStore=true`;
      }
      $.get(`${(this.galleryData.window || window).infiniteScrollUrl}from/${curTo}/to/${to}?instance=${(this.galleryData.window || window).instance}${storeParameter}`, (res) => {
        console.timeEnd('Fetching items from DB');
        console.log('Fetched items from DB', res);
        if (res && res.items && res.items.length > 0) {
          this.totalItemsCount = res.totalItemsCount;
          var items = this.concatNewItems(this.state.items, this.prepareFullscreenItems(res.items));
          utils.setStateAndLog(this, 'getMoreItems', {
            items: items
          });
          this.fetchingMoreItems = false;
        }
      });
    } else {
      // console.log('NOT Fetching items from DB', to, curTo); todo yoshi
    }

  }

  getItemsDisplayRange() {
    return (utils.isTouch()) ? 2 : 5;
  }

  getItemsToDisplay() {
    var range = this.getItemsDisplayRange();
    var startIdx = this.state.current.idx - range;
    var endIdx = this.state.current.idx + range;

    //create a fixed size items array (size = range * 2 + 1)
    var items = [];
    for (var i = startIdx; i <= endIdx; i++) {
      items.push(this.state.items[i]);
    }

    return items;
  }

  getNextitem(idx, direction) {
    var numOfitems = this.state.items.length;
    var next = idx + direction;
    return (next < 0 || next >= numOfitems) ? idx : next;
  }

  nextSlide(direction, nextIdx) {

    //this method should be called AFTER the animation is finished!

    //disable circling photos
    nextIdx = _.isUndefined(nextIdx) ? this.getNextitem(Number(this.state.current.idx), direction) : nextIdx;
    if (nextIdx === this.state.current.idx) {
      return;
    }

    var nextItem = this.getItem(nextIdx);

    if (nextIdx === false || !nextItem) {
      this.closeFullscreen();

    } else {

      this.setState({
        current: this.getCurrentItemState(nextIdx),
      }, () => {
        this.getMoreItems(nextIdx);
        this.replaceCurrentUrl();
      });

    }
  }

  //---------------------------------------| STYLES |----------------------------------------//

  onNewStyleParams(wixStyles) {
    this.createFullscreenCss(wixStyles);
    var wixStylesParsed = _.merge({}, wixStyles.numbers, wixStyles.booleans, wixStyles.colors, wixStyles.fonts);
    this.parseStyleParams(wixStylesParsed);

    // Update according to new styles
    // (due to quality / usm params change)
    utils.setStateAndLog(this, 'onNewStyleParams', {
      showInfo: ((this.styleParams.defaultShowInfoExpand == 1) && !utils.isSmallScreen()),
      items: this.prepareFullscreenItems(this.state.items),
      styleParams: this.styleParams,
      readyToRender: true
    });
  }

  getSiteColors() {
    let siteColors = null;
    let wixSkd = window.Wix;
    try {
      if (utils.isInSettings()) {
        wixSkd = window.parent.Wix;
      }
      siteColors = wixSkd.Styles.getSiteColors();
    } catch (error) {
      console.error(`fullscreen - error getting site colors`);
    }

    return siteColors;
  }

  createFullscreenCss(wixStyles) {
    const getSiteColor = (strColor) => {
      var siteColors = this.getSiteColors();
      let colorData = null;
      if (siteColors) {
        colorData = siteColors.find(colorData => colorData.reference === strColor);
      }
      return colorData ? colorData.value : null;
    };

    try {
      this.fullScreenCssCreated = true;
      var formerCssElement = document.getElementById('inlineDynamicFullscreenWixParamsCss');
      if (formerCssElement) {
        var cssSheetParent = formerCssElement.parentNode;
        cssSheetParent.removeChild(formerCssElement);
      }
      var style = document.createElement('style');
      style.setAttribute('id', 'inlineDynamicFullscreenWixParamsCss');
      style.type = 'text/css';

      const color5 = getSiteColor('color-5');

      var bgColorExpand = wixStyles.colors && wixStyles.colors.bgColorExpand && wixStyles.colors.bgColorExpand.value || '';
      var titleColorExpand = wixStyles.colors && wixStyles.colors.titleColorExpand && wixStyles.colors.titleColorExpand.value || '';
      var descriptionColorExpand = wixStyles.colors && wixStyles.colors.descriptionColorExpand && wixStyles.colors.descriptionColorExpand.value || color5;
      var actionsColorExpand = wixStyles.colors && wixStyles.colors.actionsColorExpand && wixStyles.colors.actionsColorExpand.value || '';

      var addToCartColorExpand = wixStyles.colors && wixStyles.colors.addToCartColorExpand && wixStyles.colors.addToCartColorExpand.value || '';
      var addToCartBGColorExpand = wixStyles.colors && wixStyles.colors.addToCartBackColorExpand && wixStyles.colors.addToCartBackColorExpand.value || '';
      var addToCartBorderColorExpand = wixStyles.colors && wixStyles.colors.addToCartBorderColor && wixStyles.colors.addToCartBorderColor.value || '';
      var addToCartFontExpand = wixStyles.fonts && wixStyles.fonts.addToCartFontExpand && wixStyles.fonts.addToCartFontExpand.value || '';
      addToCartFontExpand = addToCartFontExpand.substr(5);
      var addToCartBorderWidthExpand = wixStyles.numbers && wixStyles.numbers.addToCartBorderWidth || 1;

      var titleFontExpand = wixStyles.fonts && wixStyles.fonts.titleFontExpand && wixStyles.fonts.titleFontExpand.value || '';
      titleFontExpand = titleFontExpand.substr(5);
      var descriptionFontExpand = wixStyles.fonts && wixStyles.fonts.descriptionFontExpand && wixStyles.fonts.descriptionFontExpand.value || '';
      descriptionFontExpand = descriptionFontExpand.substr(5);

      var stylePrefix = '#fullscreen #fullscreen-view.fullscreen.fullscreen-bright';

      var descriptionAsRGB = utils.colorStringToObject(descriptionColorExpand);

      let customColors = null;
      var viewportAspectRatio = utils.getScreenWidth() / 320;

      if (descriptionAsRGB) {
        customColors = `
        ${stylePrefix} .products-list-container {
          border-bottom: 1px solid rgba(${descriptionAsRGB.r}, ${descriptionAsRGB.g}, ${descriptionAsRGB.b}, 0.2);
        }
        ${stylePrefix} .products-list-container .table-cell {
          border-top: 1px solid rgba(${descriptionAsRGB.r}, ${descriptionAsRGB.g}, ${descriptionAsRGB.b}, 0.2);
          height: calc(100px * ${viewportAspectRatio});
        }
        ${stylePrefix} .products-list-container .table-cell .title {
          font: ${descriptionFontExpand};
          color: ${descriptionColorExpand};
          line-height: 23px !important;
          font-size: 15px !important;
        }
        ${stylePrefix} .products-list-container .table-cell .description {
          font: ${descriptionFontExpand};
          color: rgba(${descriptionAsRGB.r}, ${descriptionAsRGB.g}, ${descriptionAsRGB.b}, 0.6);
          line-height: 23px !important;
          font-size: 13px !important;
        }
        `;
      }

      style.innerHTML =
        `
      ${stylePrefix} {
        background-color: ${bgColorExpand} !important;
      }

      ${customColors}

      ${stylePrefix} .fullscreen-side-bar,
      ${stylePrefix} .fullscreen-bottom-mobile-info {
        background-color: ${bgColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-side-bar-title,
      ${stylePrefix} .fullscreen-side-bar .fullscreen-side-bar-title {
        color: ${titleColorExpand} !important;
        font: ${titleFontExpand} !important;
      }

      ${stylePrefix} .fullscreen-side-bar-description,
      ${stylePrefix} .fullscreen-side-bar .fullscreen-side-bar-description,
      ${stylePrefix} .selected-license,
      ${stylePrefix} .checkout-link {
        color: ${descriptionColorExpand} !important;
        font: ${descriptionFontExpand};
      }

      ${stylePrefix} .fullscreen-side-bar-description .fullscreen-side-bar-description-line,
      ${stylePrefix} .fullscreen-side-bar .fullscreen-side-bar-description .fullscreen-side-bar-description-line {
        color: ${descriptionColorExpand} !important;
        font: ${descriptionFontExpand} !important;
      }

      ${stylePrefix} .fullscreen-side-bar-separator,
      ${stylePrefix} .fullscreen-side-bar .fullscreen-side-bar-separator {
        border-color: ${descriptionColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-side-bar-exif,
      ${stylePrefix} .fullscreen-side-bar .fullscreen-side-bar-exif {
        color: ${descriptionColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-side-bar-exif:after,
      ${stylePrefix} .fullscreen-side-bar .fullscreen-side-bar-exif:after {
        border-color: ${descriptionColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-side-bar-link,
      ${stylePrefix} .fullscreen-side-bar .fullscreen-side-bar-link {
        color: ${descriptionColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-side-bar-link:after,
      ${stylePrefix} .fullscreen-side-bar .fullscreen-side-bar-link:after {
        border-color: ${descriptionColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-bottom-link {
        color: ${actionsColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-side-bar-social i:not(.loved),
      ${stylePrefix} .fullscreen-side-bar-social a,
      ${stylePrefix} .fullscreen-side-bar-social button {
        color: ${descriptionColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-item i:not(.loved),
      ${stylePrefix} .fullscreen-nav i:not(.loved),
      ${stylePrefix} .fullscreen-nav a,
      ${stylePrefix} .fullscreen-nav button,
      ${stylePrefix} .fullscreen-mobile-bar i:not(.loved),
      ${stylePrefix} .fullscreen-mobile-bar a,
      ${stylePrefix} .fullscreen-mobile-bar button,
      ${stylePrefix} .fullscreen-social i:not(.loved),
      ${stylePrefix} .fullscreen-social a,
      ${stylePrefix} .fullscreen-social button {
        color: ${actionsColorExpand} !important;
      }

      ${stylePrefix} i.fullscreen-item-video-play.progallery-svg-font-icons-play-triangle {
        color: ${descriptionColorExpand} !important;
      }

      ${stylePrefix} i.fullscreen-item-video-play.progallery-svg-font-icons-play-background {
        color: ${bgColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-icon {
        background: ${bgColorExpand} !important;
        color: ${actionsColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-social-love-store {
        color: ${actionsColorExpand} !important;
      }

      ${stylePrefix} .fullscreen-mobile-bar {
        background-color: ${bgColorExpand} !important;
      }

      ${stylePrefix} .add-to-cart-button,
      ${stylePrefix} .fullscreen-side-bar .add-to-cart-button {
        color: ${addToCartColorExpand} !important;
        font: ${addToCartFontExpand};
        background: ${addToCartBGColorExpand} !important;
        border-width: ${addToCartBorderWidthExpand}px;
        border-style: solid;
        border-color: ${addToCartBorderColorExpand};
      }
      `;

      document.getElementsByTagName('head')[0].appendChild(style);

      this.injectFonts(wixStyles.googleFontsCssUrl)

    } catch (e) {
      console.error('Could not create css', e);
    }
  }

  injectFonts(fontsUrl) {
    if (!fontsUrl) {
      return
    }
    const formerFontElement = document.getElementById('inlineDynamicFullscreenWixParamsFont');
    if (formerFontElement) {
      formerFontElement.parentNode.removeChild(formerFontElement);
    }
    const font = document.createElement('link');
    font.setAttribute('id', 'inlineDynamicFullscreenWixParamsFont');
    font.setAttribute('rel', 'stylesheet');
    font.setAttribute('type', 'text/css');
    font.setAttribute('href', fontsUrl);

    document.getElementsByTagName('head')[0].appendChild(font);
  }

  getStyleParams() {
    var wixStyles = {};

    if (utils.isInWix() && !utils.isInSettings()) {
      this.readyToRender = false;
      if (this.galleryInfo.styleId) {
        Wix.Styles.getStyleParamsByStyleId(this.galleryInfo.styleId, (sp) => {
          this.onNewStyleParams(sp);
        });
      } else {
        console.error('NO STYLE ID!!!!!', this.galleryInfo);
      }
    } else if (typeof (window.styles) == 'object') {
      wixStyles = window.styles;
      this.onNewStyleParams(wixStyles);

    } else if (utils.parseGetParam('galleryStyle')) {
      var galleryStyle = utils.parseGetParam('galleryStyle');
      if (/^[\],:{}\s]*$/.test(galleryStyle.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        //the json is ok
        wixStyles = JSON.parse(galleryStyle);
        this.onNewStyleParams(wixStyles);
      }
    } else {
      this.onNewStyleParams({});
    }
  }

  parseStyleParams(wixStyles) {

    var styleParams = {
      allowDownload: false,
      allowSocial: true,
      loveButton: true,
      loveCounter: true,
      allowTitle: true,
      allowTitleExpand: true,
      allowDescriptionExpand: true,
      allowLinkExpand: true,
      allowExifExpand: false,
      defaultShowInfoExpand: true,
      showInfoExpandButton: true,
      addToCartButtonText: '',
      galleryAlignExpand: 'left'
    };

    _.merge(styleParams, _.pick(wixStyles, ['bgColorExpand', 'titleColorExpand', 'descriptionColorExpand', 'titleFontExpand', 'descriptionFontExpand', 'allowDownload', 'allowSocial', 'loveButton', 'allowTitle', 'allowTitleExpand', 'allowDescriptionExpand', 'allowExifExpand', 'allowLinkExpand', 'addToCartButtonText']));

    if (!_.isUndefined(wixStyles.loveCounter)) {
      styleParams.loveCounter = (wixStyles.loveCounter == 0);
    }

    if (!_.isUndefined(wixStyles.galleryAlignExpand)) {
      switch (wixStyles.galleryAlignExpand) {
        case 0:
        default:
          styleParams.galleryAlignExpand = 'left';
          styleParams.galleryAlignExpandIcons = {
            float: 'left'
          };
          break;
        case 1:
          styleParams.galleryAlignExpand = 'center';
          styleParams.galleryAlignExpandIcons = {
            margin: 'auto'
          };
          break;
        case 2:
          styleParams.galleryAlignExpand = 'right';
          styleParams.galleryAlignExpandIcons = {
            float: 'right'
          };
          break;
      }
    }

    if (!_.isUndefined(wixStyles.videoSpeed)) {
      styleParams.videoSpeed = wixStyles.videoSpeed;
    }
    if (!_.isUndefined(wixStyles.videoLoop)) {
      styleParams.videoLoop = wixStyles.videoLoop;
    }

    if (!_.isUndefined(wixStyles.defaultShowInfoExpand)) {
      styleParams.defaultShowInfoExpand = (wixStyles.defaultShowInfoExpand === 1);
      styleParams.showInfoExpandButton = versionManager.useFullScreenMoreinfoButtonAlways() ? (wixStyles.defaultShowInfoExpand != 2) : (wixStyles.defaultShowInfoExpand === 0);
    } else {
      styleParams.showInfoExpandButton = versionManager.useFullScreenMoreinfoButtonAlways();
    }

    if (!_.isUndefined(wixStyles.addToCartButtonText)) {
      styleParams.addToCartButtonText = String(wixStyles.addToCartButtonText);
    }

    styleParams.sharpParams = {
      quality: 90,
      usm: {}
    };

    if (!_.isUndefined(wixStyles.usmToggle) && wixStyles.usmToggle == true) {

      if (!_.isUndefined(wixStyles.imageQuality)) {
        styleParams.sharpParams.quality = wixStyles.imageQuality;
      }
      if (!_.isUndefined(wixStyles.usm_a)) {
        styleParams.sharpParams.usm.usm_a = (wixStyles.usm_a || 0) / 100;
      }
      if (!_.isUndefined(wixStyles.usm_r)) {
        styleParams.sharpParams.usm.usm_r = wixStyles.usm_r;
      }
      if (!_.isUndefined(wixStyles.usm_t)) {
        styleParams.sharpParams.usm.usm_t = (wixStyles.usm_t || 0) / 255;
      }
    }

    this.styleParams = styleParams;

    return styleParams;
  }

  //--------------------------------------| BEHAVIOUR |--------------------------------------//

  orientationChange() {
    utils.fixViewport('Fullscreen - oriantation change');
    this.resize();
  }

  expandBrowser() {
    if (!this.isBrowserExpanded()) { // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }

  prepareToClose() {

    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;

    this.clearEvents();

    this.navigatedInto = false;

    utils.setStateAndLog(this, 'closeFullscreen', {
      showInfo: false,
      readyToRender: false
    });

    //save current items to the window
    try {
      const worker = utils.getWorkerWindow();
      if (worker) {
        worker['pro-gallery-data-' + this.galleryInfo.compId].fullscreenData = {
          currentGalleryItems: this.state.items,
          currentGalleryItemIdx: this.state.current.idx,
          currentHashtag: this.galleryInfo.hashtag,
        }
        worker['pro-gallery-hashtag-filter'] = this.galleryInfo.hashtag;
      }
    } catch (e) {
      //
    }

  }

  closeFullscreen() {

    if (this.isBrowserExpanded()) {

      this.expandBrowser();

    } else {

      this.prepareToClose();

      if (utils.isInWix()) {

        if (this.galleryInfo.pageId) {
          Wix.navigateToPage(this.galleryInfo.pageId, { noTransition: true });
        } else if (this.galleryInfo.compId) {
          Wix.navigateToComponent(this.galleryInfo.compId);
        } else if (!this.isPreload() && !utils.isInSettings()) {
          Wix.getSitePages((pages) => {
            let homePage = _.find(pages, { 'isHomepage': true });
            if (homePage) {
              Wix.navigateToPage(homePage.id, { noTransition: true });
            }
          });

        }

      } else {
        utils.removeItemHashParam(window.location.href);
        //ReactDOM.unmountComponentAtNode(document.getElementById('gallery-fullscreen'));
        $('#gallery-fullscreen').hide();
        $('#content').show();
      }
    }
  }

  replaceCurrentUrl(idx, item) {

    if (!utils.isInWix()) return;

    if (this.isPreload()) return;

    if (this.totalItemsCount <= 1) return; //when there is only one item (landing on the fullscreen) - do not change the url

    if (_.isUndefined(idx)) idx = this.state.current.idx;
    if (_.isUndefined(item)) item = this.state.current.item;

    var newUrl = this.galleryInfo.compId + '/' + item.id + '/' + idx + '/?i=' + idx + '&p=' + this.galleryInfo.pageId + '&s=' + this.galleryInfo.styleId;

    if (!utils.isEditor()) {
      Wix.replaceSectionState(newUrl);
    }
  }

  resize() {
    console.log('Fullscreen Class - RESIZE');
    utils.setStateAndLog(this, 'resize', {
      items: this.prepareFullscreenItems(this.state.items),
      window: this.getWindowState()
    });
  }

  toggleInfo(forceVal) {
    utils.setStateAndLog(this, 'toggleInfo', {
      showInfo: (_.isUndefined(forceVal) ? !this.state.showInfo : forceVal)
    });
  }

  toggleShopFrame() {
    this.setState({
      showShopFrame: !this.state.showShopFrame
    });
  }

  toggleMobileShopFrame() {
    this.setState({
      showMobileShopFrame: !this.state.showMobileShopFrame
    });
  }

  toggleShareScreen() {
    this.setState({
      showShareScreen: !this.state.showShareScreen
    });
  }

  //---------------------------------------| RENDER |---------------------------------------//

  render() {

    if (!this.state.readyToRender) {
      if (utils.isVerbose()) { //todo yoshi
        console.log('Not rendering Fullscreen - state not ready', this.state);
      }
      return false;
    }
    var fullscreenItemProps = _.merge({
      isNewEditor: this.props.isNewEditor,
      isSettings: utils.isInSettings(),
      items: this.getItemsToDisplay(),
      totalItems: this.totalItemsCount,
      current: this.getCurrentItemState(),
      styleParams: this.styleParams,
      window: this.getWindowState(),
      showInfo: this.shouldShowInfo(),
      showMobileShopFrame: this.state.showMobileShopFrame,
      showShopFrame: utils.isStoreGallery(),
      showShareScreen: this.state.showShareScreen,
      galleryInfo: this.galleryInfo,
      navigatedInto: this.navigatedInto,
      actions: {
        toggleInfo: this.toggleInfo.bind(this),
        expandBrowser: this.expandBrowser.bind(this),
        close: this.closeFullscreen.bind(this),
        next: this.nextSlide.bind(this),
        toggleShopFrame: this.toggleShopFrame.bind(this),
        toggleMobileShopFrame: this.toggleMobileShopFrame.bind(this),
        toggleShareScreen: this.toggleShareScreen.bind(this)
      }
    }, { demoMode: this.props.demoModeParams });

    if (this.props.store) {
      fullscreenItemProps.store = this.props.store;
    }

    if (utils.isDev()) {
      // console.log("Render FullscreenContainer", fullscreenItemProps); todo yoshi
    }

    return this.state.watermarkReady && (
      <FullscreenView
        photoId={this.state.current.item.itemId}
        {...fullscreenItemProps}
        />
    );
  }
}

export default FullscreenContainer;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenContainer.js